export enum enumVoyageStatusTab {
  ALL,
  ACTIVE,
  PUBLISHED,
  IN_TRANSIT,
  AT_ARRIVAL_PORT,
  AT_DESTINATION_WAREHOUSE,
  DRAFTS,
  EXPIRED,
}
